<template>
  <canvas id="graph-user-growth" height="70"></canvas>
</template>

<script>
  import Chart from 'chart.js'
  import { keys, max, values } from 'lodash'
  import { mapActions } from 'vuex'
  export default {
    data () {
      return {
        chart: null,
        growth: []
      }
    },

    created () {
      this.getUserGrowthGraph()
        .then((response) => {
          this.growth = response.data
        })
        .then(this.initializeGraph)
    },

    methods: {
      ...mapActions('dashboard', ['getUserGrowthGraph']),

      initializeGraph () {
        if (this.chart) {
          this.chart.destroy()
        }

        this.chart = new Chart(this.$el.getContext('2d'), {
          type: 'line',
          data: {
            labels: keys(this.growth.carriers),
            datasets: [
              {
                label: 'Clients',
                lineTension: 0.2,
                backgroundColor: 'rgba(54,175,227,0.5)',
                borderColor: 'rgba(54,175,227,1)',
                pointBackgroundColor: 'rgba(54,175,227,1)',
                pointBorderColor: '#fff',
                data: values(this.growth.clients)
              },
              {
                label: 'Carriers',
                lineTension: 0.2,
                backgroundColor: 'rgba(54,220,227,0.5)',
                borderColor: 'rgba(54,220,227,0.7)',
                pointBackgroundColor: 'rgba(54,220,227,1)',
                pointBorderColor: '#fff',
                data: values(this.growth.carriers)
              }
            ]
          },
          options: {
            responsive: true,
            scales: {
              yAxes: [{
                ticks: {
                  callback: function (value, index, values) {
                    if (Math.floor(value) === value) {
                      return value
                    }
                  },
                  max: max(values(this.growth.carriers)) + 1,
                  beginAtZero: true
                }
              }]
            }
          }
        })
      }
    },

    beforeDestroy () {
      if (this.chart) {
        this.chart.destroy()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UserGrowthGraph.vue?69e2660e